<template>
    <div
        class="common-drop-zone-item"
        v-bind:class="{ '_error': error, '_loading': isLoading, '_loaded': file }"
        v-bind:title="filename"
        v-on:click="open"
    >
        <div class="common-drop-zone-item__icon">
            <icon
                name="upload-file-done"
                width="14"
                height="18"
                v-if="!isLoading"
            />
            <ui-loader v-else />
        </div>
        <span class="common-drop-zone-item__name">{{ filename }}</span>
        <div
            class="common-drop-zone-item__icon _black" v-if="file && file.id"
            v-on:click.stop="$emit('delete', file.id)"
            title="Удалить файл"
        >
            <icon name="trash" width="20" height="20" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'common-drop-zone-item',
    props: {
        filename: String,
        file: {
            type: Object,
            default: null,
        },
        isLoading: Boolean,
        error: Boolean,
    },
    methods: {
        open() {
            if (this.file && this.file.image_file) {
                window.open(this.file.image_file, '_blank');
            }
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.common-drop-zone-item {
    .typography-body();

    position: relative;

    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 12px;

    height: 56px;
    padding: 16px;

    border-radius: @border-radius-md;
    border: 1px solid @color-gray-light-secondary;

    &._error {
        border-color: @color-accent-negative;
    }
    &._loading {
        background-color: @color-gray-lighter;
    }
    &._loaded {
        cursor: pointer;
    }

    &__icon {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 24px;
        height: 24px;
        color: @color-positive;

        &._black {
            color: @color-gray-darker;
            cursor: pointer;
        }
    }

    &__name {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
}
</style>
